import { useState, useCallback } from 'react';
import { eventService } from '../services/eventService';

export interface ApplyProfileData {
  fullName?:   string;
  furigana?:   string;
  university?: string;
  faculty?:    string;
  phone?:      string;
  birthDate?:  string;
  gender?:     string;
}

interface UseEventParticipationReturn {
  isSubmitting: boolean;
  apply: (eventId: number, profileData?: ApplyProfileData) => Promise<{ success: boolean; message: string }>;
  cancel: (eventId: number) => Promise<{ success: boolean; message: string }>;
}

export const useEventParticipation = (): UseEventParticipationReturn => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const apply = useCallback(async (eventId: number, profileData?: ApplyProfileData) => {
    setIsSubmitting(true);
    try {
      await eventService.participate(eventId, profileData as Record<string, string>);
      return { success: true, message: '参加申込が完了しました' };
    } catch (err: any) {
      const code = err?.response?.data?.error?.code;
      const messages: Record<string, string> = {
        ALREADY_PARTICIPATED: 'すでに参加申込済みです',
        CAPACITY_FULL:        '定員に達しています',
        DEADLINE_PASSED:      '申込締切を過ぎています',
        EVENT_ENDED:          'このイベントは終了しています',
        EVENT_NOT_FOUND:      'イベントが見つかりません',
      };
      return { success: false, message: messages[code] ?? '参加申込に失敗しました' };
    } finally {
      setIsSubmitting(false);
    }
  }, []);

  const cancel = useCallback(async (eventId: number) => {
    setIsSubmitting(true);
    try {
      await eventService.cancelParticipation(eventId);
      return { success: true, message: '参加をキャンセルしました' };
    } catch (err: any) {
      const code = err?.response?.data?.error?.code;
      const messages: Record<string, string> = {
        NOT_PARTICIPATED: '参加申込が見つかりません',
        EVENT_NOT_FOUND:  'イベントが見つかりません',
      };
      return { success: false, message: messages[code] ?? 'キャンセルに失敗しました' };
    } finally {
      setIsSubmitting(false);
    }
  }, []);

  return { isSubmitting, apply, cancel };
};
